var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.freeSpace)?_c('tr',[_vm._t("default")],2):_c('tr',{staticClass:"table-row",class:`${_vm.breakpoint} ${_vm.mobileStriped && _vm.striped ? 'striped' : ''} ${
            _vm.bottomRounded ? 'bottom-rounded' : ''
        } ${_vm.noPadding ? 'p-0' : 'p-2 px-3'} ${
            _vm.expandable ? 'expandable' : ''
        } ${_vm.expanded ? 'expanded' : ''} ${
            _vm.childExpanded ? 'child-expanded' : ''
        } ${_vm.trSpacing ? 'tr-spacing' : ''} ${
            _vm.expandableContainer ? 'expandable-container' : ''
        } `},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }